// Global IntersectionObserver instance for reveal animation
let sharedObserver = null

function getSharedObserver() {
  if (typeof window === 'undefined') return null

  if (!sharedObserver && 'IntersectionObserver' in window) {
    sharedObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed')
            // Disconnect observation once revealed to save resources
            sharedObserver.unobserve(entry.target)
          }
        })
      },
      {
        root: null,
        rootMargin: '0px 0px -40px 0px',
        threshold: 0.08
      }
    )
  }

  return sharedObserver
}

export const vReveal = {
  mounted(el, binding) {
    const direction = binding.arg || binding.value?.direction || 'down'
    el.classList.add(direction === 'up' ? 'v-reveal-init-up' : 'v-reveal-init')

    const observer = getSharedObserver()
    if (observer) {
      observer.observe(el)
    } else {
      el.classList.add('is-revealed')
    }
  },
  unmounted(el) {
    const observer = getSharedObserver()
    if (observer) {
      observer.unobserve(el)
    }
  }
}

// Global helper function for legacy DOM content dynamically rendered via app.js
if (typeof window !== 'undefined') {
  window.__initNeobrutalistScrollObserver = (container = document) => {
    const observer = getSharedObserver()
    if (!observer) return

    const elements = container.querySelectorAll('[data-reveal], .card, .course-card, .assignment-item, .student-record-card, .lecturer-record-card')
    elements.forEach((el) => {
      if (!el.hasAttribute('data-reveal')) {
        el.setAttribute('data-reveal', 'down')
      }
      if (!el.hasAttribute('data-interactive')) {
        el.setAttribute('data-interactive', 'true')
      }
      observer.observe(el)
    })
  }
}
